module.exports = __webpack_public_path__ + "img/ShortActingBooster.63d6a330.svg";